import React from 'react';
import { Spinner } from '../Spinner';
import './LoadingOverlay.css';

export interface LoadingOverlayProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Whether the overlay is active */
  active: boolean;
  /** Accessible label for the spinner */
  label?: string;
  /** Spinner size */
  spinnerSize?: 'small' | 'medium' | 'large';
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  active,
  label = 'Loading',
  spinnerSize = 'large',
  children,
  className = '',
  ...rest
}) => {
  const classes = ['hi-ui-loading-overlay', className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {children}
      {active && (
        <div className="hi-ui-loading-overlay__backdrop" aria-live="polite">
          <Spinner size={spinnerSize} aria-label={label} />
        </div>
      )}
    </div>
  );
};
